/* shto-overstock-hero countdown (Kevin 2026-10-05): a new visitor starts at the section's start time (11:17:04 by default).
   Their end time is kept in this browser (localStorage), so refreshing or coming back doesn't start it again. When it reaches
   zero it starts again at 24 hours. Updates once a second, only while the countdown is on screen. If storage is blocked
   (private windows), it still counts down from the start time for that visit. */
(function () {
  if (window.ShtoOverstockCountdown) return;
  window.ShtoOverstockCountdown = true;
  var DAY = 24 * 3600 * 1000;
  var visible = new Set();
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  function startMs(el) {
    var p = (el.getAttribute('data-start') || '11:17:04').split(':').map(function (v) { return parseInt(v, 10) || 0; });
    return ((p[0] || 0) * 3600 + (p[1] || 0) * 60 + (p[2] || 0)) * 1000;
  }
  function read(key) { try { return Number(window.localStorage.getItem(key)) || 0; } catch (e) { return 0; } }
  function write(key, value) { try { window.localStorage.setItem(key, String(value)); } catch (e) {} }

  function endFor(el) {
    var key = 'shto-countdown:' + (el.getAttribute('data-key') || 'hero');
    var now = Date.now();
    var end = el.shtoEnd || read(key);
    if (!end) end = now + startMs(el);
    // Past zero: start again at 24 hours (as many days on as needed).
    if (end <= now) end += Math.ceil((now - end + 1) / DAY) * DAY;
    if (end !== el.shtoEnd) { el.shtoEnd = end; write(key, end); }
    return end;
  }
  function paint(el) {
    var left = Math.max(0, Math.floor((endFor(el) - Date.now()) / 1000));
    var parts = { h: Math.floor(left / 3600), m: Math.floor((left % 3600) / 60), s: left % 60 };
    el.querySelectorAll('[data-shto-unit]').forEach(function (unit) {
      var text = pad(parts[unit.getAttribute('data-shto-unit')]);
      if (unit.textContent !== text) unit.textContent = text;
    });
  }
  function tick() {
    visible.forEach(paint);
    setTimeout(tick, 1000 - (Date.now() % 1000) + 5);
  }
  function start() {
    var timers = Array.prototype.slice.call(document.querySelectorAll('[data-shto-countdown]'));
    if (!timers.length) return;
    timers.forEach(paint);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { paint(e.target); visible.add(e.target); } else visible.delete(e.target); });
      });
      timers.forEach(function (el) { io.observe(el); });
    } else timers.forEach(function (el) { visible.add(el); });
    tick();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
